// extracted by mini-css-extract-plugin
export default {"textInputWithButtonAndDropdown":"Do5V","dropdown":"lpB2"};